import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout';
import api from '../../utils/api';
import { MessageSquare, Clock, CheckCircle, Send } from 'lucide-react';

const AdminSupport = () => {
  const [tickets, setTickets] = useState([]);
  const [filter, setFilter] = useState('all');
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [reply, setReply] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTickets();
  }, [filter]);

  const fetchTickets = async () => {
    try {
      const res = await api.get('/admin/support/tickets', {
        params: filter !== 'all' ? { status: filter } : {}
      });
      setTickets(res.data);
      setLoading(false);
    } catch (err) {
      console.error('Failed to fetch tickets:', err);
      setLoading(false);
    }
  };

  const handleStatusUpdate = async (ticketId, status) => {
    try {
      await api.post(`/admin/support/tickets/${ticketId}/status`, null, { params: { status } });
      alert('Ticket status updated');
      fetchTickets();
      setSelectedTicket(null);
    } catch (err) {
      alert('Failed to update status');
    }
  };

  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-heading font-bold text-gray-900">Support Tickets</h1>
          <p className="text-gray-600 mt-1">{tickets.length} tickets</p>
        </div>

        {/* Filters */}
        <div className="flex gap-2">
          {['all', 'open', 'pending', 'resolved', 'closed'].map((status) => (
            <button
              key={status}
              onClick={() => setFilter(status)}
              className={`px-4 py-2 rounded-lg text-sm font-medium ${
                filter === status ? 'bg-primary text-white' : 'bg-gray-100 text-gray-700'
              }`}
            >
              {status.charAt(0).toUpperCase() + status.slice(1)}
            </button>
          ))}
        </div>

        {/* Tickets List */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {tickets.map((ticket) => (
            <div key={ticket.id} className="bg-white rounded-lg border border-gray-200 p-6">
              <div className="flex items-start justify-between mb-3">
                <div>
                  <h3 className="font-semibold text-gray-900">{ticket.title}</h3>
                  <p className="text-sm text-gray-600">{ticket.userName} - {ticket.userEmail}</p>
                </div>
                <span className={`px-2 py-1 rounded text-xs font-semibold ${
                  ticket.status === 'open' ? 'bg-primary-light text-primary' :
                  ticket.status === 'resolved' ? 'bg-success-light text-success' :
                  ticket.status === 'closed' ? 'bg-gray-200 text-gray-600' :
                  'bg-warning-light text-warning'
                }`}>
                  {(ticket.status || 'open').toUpperCase()}
                </span>
              </div>
              
              <p className="text-sm text-gray-700 mb-3">{ticket.message}</p>
              <p className="text-xs text-gray-500 mb-3">Category: {ticket.category}</p>

              <div className="flex gap-2">
                {ticket.status === 'open' && (
                  <button
                    onClick={() => handleStatusUpdate(ticket.id, 'pending')}
                    className="flex-1 bg-warning text-white py-2 rounded-lg text-sm font-semibold"
                  >
                    Mark Pending
                  </button>
                )}
                {(ticket.status === 'open' || ticket.status === 'pending') && (
                  <button
                    onClick={() => handleStatusUpdate(ticket.id, 'resolved')}
                    className="flex-1 bg-success text-white py-2 rounded-lg text-sm font-semibold"
                  >
                    Resolve
                  </button>
                )}
                {ticket.status === 'resolved' && (
                  <button
                    onClick={() => handleStatusUpdate(ticket.id, 'closed')}
                    className="flex-1 bg-gray-600 text-white py-2 rounded-lg text-sm font-semibold"
                  >
                    Close
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>

        {tickets.length === 0 && (
          <div className="text-center py-12 bg-white rounded-lg">
            <MessageSquare className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <p className="text-gray-600">No support tickets</p>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default AdminSupport;
